import { useState } from 'react';
import { FlexBox } from 'src/styles/OverviewStyle';
import styled from 'styled-components';

interface IProps {
  title: string;
  summary: string;
  thumbnail: string;
  url?: string;
}

WebTextImageModal.defaultProps = {
  url: '',
};

export default function WebTextImageModal({
  title,
  summary,
  thumbnail,
  url,
}: IProps) {
  const [showModal, setShowModal] = useState(true);

  if (showModal)
    return (
      <ModalContainer>
        <ModalTitle>{title}</ModalTitle>
        <ModalExplanation>{summary}</ModalExplanation>
        <ModalImgBoard>
          {url ? (
            <img
              style={{ cursor: 'pointer' }}
              onClick={() => {
                window.open(url);
              }}
              src={thumbnail}
              alt="이미지"
            />
          ) : (
            <img src={thumbnail} alt="이미지" />
          )}

          <CloseButton onClick={() => setShowModal(false)}>
            팝업 닫기
          </CloseButton>
        </ModalImgBoard>
      </ModalContainer>
    );
  return null;
}

const ModalContainer = styled(FlexBox)`
  position: fixed;
  top: 10%;
  left: 5%;
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.backgroundColor};

  border-radius: 16px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.8);

  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const ModalTitle = styled.h1`
  margin-top: 12px;

  color: ${({ theme }) => theme.colors.fontColor};
  text-align: center;
  font-family: Cafe24Ohsquare;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 33.6px */
`;

const ModalExplanation = styled.h2`
  margin-bottom: 12px;

  color: #101010;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 18.2px */
`;

const ModalImgBoard = styled(FlexBox)`
  width: 100%;
  padding: 16px 0;
  background-color: white;

  padding: 16px 20px;
  border-radius: 0px 0px 16px 16px;

  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 28px;
  img {
    width: 328px;
    height: auto;
  }
`;

const CloseButton = styled.button`
  border-radius: 8px;
  background: #101010;

  color: #fff;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 21px */
  letter-spacing: -0.225px;

  display: flex;
  width: 100%;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;
